import { env } from 'src/env.mjs';
import { Vertical } from './Verticals';

const portalPath = env.NEXT_PUBLIC_USER_PORTAL_PATH;

const PortalRoutes = {
    ADDONS: `${portalPath}/addons`,
    APPOINTMENTS: `${portalPath}/appointments`,
    BOOK_RENEWAL: `${portalPath}/booking/np/renewal`,
    BOOK_VC_CONSULT: (quizToken: string) =>
        `${portalPath}/booking?quiz_token=${quizToken}`,
    BOOK_VC_CONSULT_TIME: (quizToken: string, type: string) =>
        `${portalPath}/booking/time_select?quiz_token=${quizToken}&quizType=${type}`,
    CONTACT_US: `${portalPath}/contact`,
    CONTACT: `${portalPath}/contact`,
    MEDICAL_SUPPORT: `${portalPath}/medical_support`,
    MENTAL_HEALTH_QUIZ: `${portalPath}/quizzes/mental_health_quiz`,
    NOTIFICATIONS: `${portalPath}/notifications`,
    ORDERS: `${portalPath}/orders`,
    PROFILE: `${portalPath}/profiles`,
    REFERRAL: `${portalPath}/referral`,
    REWARDS: `${portalPath}/rewards`,
    SIGN_OUT: `${portalPath}/users/sign_out`,
    SUBSCRIPTIONS: `${portalPath}/subscriptions`,
    SUPPORT_OPTIONS: `${portalPath}/support/support-options?from=chat`,
    SUPPORT: `${portalPath}/support`,
    USER_SIGN_IN: `${portalPath}/users/sign_in`,
    SCRIPT_CONSENT: (quizToken: string, vertical: Vertical) =>
        `${portalPath}/plans/script_consent_b?quiz_token=${quizToken}&type=${vertical}`,
};
export default PortalRoutes;
